import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container, Row, Col, NavLink, Nav, NavItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import 'react-widgets/dist/css/react-widgets.css';
import './QuestionnaireNav.css';

function getCurrentQuestionnaireName() {
  const pathName = window.location.pathname;
  const questionnaireName = pathName.split("/")[2];
  return questionnaireName;
}

const Prop = {
  data: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]).isRequired,
  complete: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};

const NavTitle = ({ complete, data, location }) => {
  const navClass = classnames({
    QuNavComplete: complete[data.linkId],
    QuNav: !complete[data.linkId],
  });
  const questionnaireName = getCurrentQuestionnaireName()
  return (
    <Nav pills>
      <NavItem style={{ width: '100%' }}>
        <NavLink
          active={data.linkId === location.pathname.split('/').pop()}
          className={navClass}
          tag={Link}
          to={`/questionnairePage/${questionnaireName}/group/${data.linkId}`}
        >
          {data.text}
        </NavLink>
      </NavItem>
    </Nav>
  );
};

// make NavTitle component with data (titles of the sections)
const Group = ({ data, complete, location }) => (
  <Row>
    <Col>
      <NavTitle complete={complete} data={data} location={location} />
    </Col>
  </Row>
);

// logic to check if type group then make a group component
const Item = ({ data, complete, location }) => (
  <div>
    {data.type === 'group' ? (
      <Group complete={complete} data={data} location={location} />
    ) : null}
  </div>
);

// if data has an item (array) then map it to Item
const QuestionnaireNav = ({ data, complete, router }) => (
  <Container className="QuNav">
    {data.item
      ? data.item.map(item => (
        <Item
          complete={complete}
          key={item.linkId}
          data={item}
          location={router.location}
        />
      ))
      : null}
  </Container>
);

// Proptypes
NavTitle.propTypes = {
  tag: PropTypes.string,
  ...Prop,
}.isRequired;
Group.propTypes = Prop;
Item.propTypes = Prop;
QuestionnaireNav.propTypes = Prop;

export default connect(
  state => ({
    router: state.router,
  }),
  {},
)(QuestionnaireNav);



// WEBPACK FOOTER //
// ./src/components/QuestionnaireNav/QuestionnaireNav.js